module.exports = __webpack_public_path__ + "img/Slide6.2b06c037.png";